import { QTypography } from '@kw/quokka-ui';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

export const RequestAnalysisHeader = () => {
  const { pathname } = useLocation();

  let label = 'Request Analysis';

  // the submission confirmation is only reachable from the store search flow, so it keeps that breadcrumb
  if (pathname.includes('/search') || pathname.includes('/submission-confirmation')) {
    label += ' / Search for Store Apps';
  } else if (pathname.includes('/bulk-submit')) {
    label += ' / Bulk Submit';
  }

  return <StyledHeaderText>{label}</StyledHeaderText>;
};

const StyledHeaderText = styled(QTypography)`
  flex-grow: 1;
  line-height: 45px;
  color: ${props => props.theme.palette.text.secondary};
  margin-left: -4px;
` as typeof QTypography;

// @ts-ignore
StyledHeaderText.defaultProps = {
  component: 'h1',
  variant: 'h1Regular',
};
